import React from 'react';
import {
  IUser, UserRemoteWorkTypes, UserStatusMarkers, useStore,
} from '@utils';
import { RemoteWork, UserAvailable, UserUnavailable } from '@components';
import { MembersStore } from '../../store';

export const getMemberIcon = (member: IUser, isShowTooltip: boolean, className?: string) => {
  className = className ?? '';

  const membersStore = useStore(MembersStore);
  const memberStatus = membersStore.membersStatus.has(member.id) 
    ? membersStore.membersStatus.get(member.id)[0]
    : null;

  if (memberStatus?.marker === UserStatusMarkers.UNAVAILABLE_FOR_OTHER_REASON) {
    const tooltip = isShowTooltip 
      ? memberStatus?.description ?? 'Пользователя нет на месте'
      : null;
     
    return (
      <UserUnavailable 
        divClassName={className} 
        tooltip={tooltip}
      />
    );
  } else if (
    memberStatus?.marker === UserStatusMarkers.REMOTE_WORK
      || member.remoteWorkType === UserRemoteWorkTypes.CAN_COME
      || member.remoteWorkType === UserRemoteWorkTypes.REMOTE
  ) {
    const tooltip = isShowTooltip   
      ? memberStatus?.description ?? 'Удаленная работа'
      : null;
    
    return (
      <RemoteWork 
        divClassName={className} 
        tooltip={tooltip} 
      />
    );
  }
  return (
    <UserAvailable 
      divClassName={className} 
      tooltip={isShowTooltip ? 'В офисе' : null}
    />
  );
};
